<div class="patient-modal">
  <!-- ================= HEADER ================= -->
  <div class="patient-modal-header">

    <div class="header-content">

      <div class="header-icon">
        <mat-icon class="patient-icon">
          person_add
        </mat-icon>
      </div>
      <div>
        <h2>Patient Onboarding</h2>
        <p>
          Create a new patient profile and start requisition workflow
        </p>
      </div>
    </div>
    <button type="button" class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <!-- ================= BODY ================= -->
  <div class="patient-modal-body">
    <!-- ================= MOBILE DETAILS ================= -->
    <div class="form-card">
      <div class="section-title">
        <mat-icon>phone</mat-icon>
        Contact Information
      </div>
      <div class="form-row">
        <!-- PRIMARY MOBILE -->
        <div class="field">
          <label>
            Mobile Number <span class="required">*</span>
          </label>
          <div class="mobile-wrapper">
            <div class="country-code">
              +91
            </div>
            <input type="text" maxlength="10" class="primary-mobile-input" [(ngModel)]="mobileNumber"
              (input)="onMobileInput()" placeholder="Enter mobile number">

            <!-- <button type="button" class="confirm-btn" (click)="confirmPrimaryMobile()" [disabled]="isConfirmLoading">

              <span *ngIf="!isConfirmLoading">
                Confirm
              </span>

              <span *ngIf="isConfirmLoading">
                Checking...
              </span>

            </button> -->
          </div>
          <!-- CONFIRMED -->
          <div *ngIf="isOTPConfirmed" class="mobile-confirmed">
            <mat-icon>
              check_circle
            </mat-icon>
            Mobile number confirmed
          </div>
        </div>
        <!-- SECOND MOBILE -->
        <div class="field">
          <label>
            Second Mobile Number
          </label>
          <div class="mobile-wrapper">
            <div class="country-code">
              +91
            </div>
            <input type="text" maxlength="10" [(ngModel)]="secondMobileNumber" (input)="onSecondMobileInput()"
              placeholder="Optional">
          </div>
        </div>
      </div>
    </div>
    <!-- ================= BASIC INFORMATION ================= -->
    <div class="form-card">

      <div class="section-title">

        <mat-icon>badge</mat-icon>

        Basic Information

      </div>


      <div class="form-row">

        <!-- FIRST NAME -->

        <div class="field">

          <label>
            First Name <span class="required">*</span>
          </label>

          <input type="text" [(ngModel)]="selectedFormValue.firstname" placeholder="First name">

        </div>


        <!-- MIDDLE NAME -->

        <div class="field">

          <label>
            Middle Name
          </label>

          <input type="text" [(ngModel)]="selectedFormValue.middlename" placeholder="Middle name">

        </div>


        <!-- LAST NAME -->

        <div class="field">

          <label>
            Last Name <span class="required">*</span>
          </label>

          <input type="text" [(ngModel)]="selectedFormValue.lastname" placeholder="Last name">

        </div>

      </div>

    </div>


    <!-- ================= AGE / DOB / GENDER ================= -->

    <div class="form-card">

      <div class="section-title">

        <mat-icon>calendar_month</mat-icon>

        Age & Gender

      </div>


      <div class="form-row age-gender-row">

        <!-- DOB -->

        <div class="field">

          <label>
            Choose Birth Date <span class="required">*</span>
          </label>

          <mat-form-field appearance="outline" class="full-width">

            <input matInput [matDatepicker]="dobPicker" [(ngModel)]="dob" [max]="todayDate" (dateChange)="getAge()"
              placeholder="mm/dd/yyyy" readonly>

            <mat-datepicker-toggle matSuffix [for]="dobPicker">

            </mat-datepicker-toggle>

            <mat-datepicker #dobPicker>
            </mat-datepicker>

          </mat-form-field>

        </div>


        <!-- AGE -->

        <div class="field">

          <label>
            Age (Years)
          </label>

          <input type="text" [(ngModel)]="ageYears" (focus)="onAgeFieldFocus()" (ngModelChange)="addAge()"
            (keypress)="validateNumber($event)" placeholder="Auto-calculated">

        </div>


        <!-- GENDER -->

        <div class="field">

          <label>
            Gender <span class="required">*</span>
          </label>

          <div class="gender-list">

            <div *ngFor="let item of genderArry; let i = index" class="gender-card" [class.active]="item.selected"
              (click)="selectModalValueGender(i)">

              <span class="gender-radio">

                <span class="radio-dot" [class.selected]="item.selected">
                </span>

              </span>

              {{ item.name }}

            </div>

          </div>

        </div>

      </div>


      <!-- AGE WARNING -->

      <div *ngIf="ageWarning" class="warning-box">

        <mat-icon>
          warning
        </mat-icon>

        {{ ageWarning }}

      </div>

    </div>


    <!-- ================= ADDRESS ================= -->

    <div class="form-card">

      <div class="section-title">

        <mat-icon>location_on</mat-icon>

        Address Information

      </div>


      <div class="form-row">

        <!-- ADDRESS -->

        <div class="field">

          <label>
            Address
          </label>

          <input type="text" [(ngModel)]="patientAddress" placeholder="House no., street, area">

        </div>


        <!-- LOCALITY -->

        <div class="field">

          <label>
            Locality
          </label>

          <input type="text" [(ngModel)]="patientLocality" placeholder="Locality / Landmark">

        </div>


        <!-- CITY -->

        <div class="field">

          <label>
            City
          </label>

          <input type="text" [(ngModel)]="patientCity" placeholder="City name">

        </div>

      </div>


      <div class="form-row">

        <!-- PINCODE -->

        <div class="field">

          <label>
            Pincode
          </label>

          <input type="text" maxlength="6" [(ngModel)]="patientPincode" (keypress)="validateNumber($event)"
            placeholder="6-digit pincode">

        </div>


        <!-- LANGUAGE -->

        <div class="field language-field">

          <label>
            Preferred Language
          </label>

          <select [(ngModel)]="selectedLanguage">

            <option value="">
              Select language
            </option>

            <option value="English">
              English
            </option>

            <option value="Hindi">
              Hindi
            </option>

            <option value="Marathi">
              Marathi
            </option>

          </select>

        </div>

      </div>

    </div>

  </div>


  <!-- ================= FOOTER ================= -->

  <div class="patient-modal-footer">

    <button type="button" class="cancel-btn" (click)="close()">

      Cancel

    </button>


    <button type="button" class="save-btn" (click)="onSubmitButtonn()" [disabled]="showLoading ">
      <!-- || !isOTPConfirmed -->
      <mat-icon *ngIf="!showLoading">
        check
      </mat-icon>

      <span *ngIf="!showLoading">
        Create Patient
      </span>

      <span *ngIf="showLoading">
        Creating...
      </span>

    </button>

  </div>

</div>

<!-- =========================================================
     EXISTING PATIENT / SAME RMN MODAL
========================================================= -->

<ng-template #patientListModal let-modal>

  <div class="same-rmn-modal">

    <!-- ================= HEADER ================= -->

    <div class="same-rmn-header">

      <div class="same-rmn-header-content">

        <div class="same-rmn-header-icon">

          <mat-icon>
            person_search
          </mat-icon>

        </div>

        <div>

          <h5>
            Existing Patient Found
          </h5>

          <p>
            A patient already exists with this mobile number.
          </p>

        </div>

      </div>


      <button type="button" class="same-rmn-close" (click)="closeExistingPatientModal(modal)">

        <mat-icon>
          close
        </mat-icon>

      </button>

    </div>


    <!-- ================= BODY ================= -->

    <div class="same-rmn-body">

      <!-- WARNING -->

      <div class="same-rmn-warning">

        <div class="same-rmn-warning-icon">

          <mat-icon>
            warning
          </mat-icon>

        </div>

        <div>

          <strong>
            Same RMN found
          </strong>

          <p>
            Select the patient you want to continue with.
          </p>

        </div>

      </div>


      <!-- PATIENT LIST -->

      <div class="same-rmn-patient-list" *ngIf="patientList.length > 0">

        <div *ngFor="let patient of patientList; let i = index" class="same-rmn-patient-card"
          [class.selected]="selectedPatient === patient">


          <!-- AVATAR -->

          <div class="same-rmn-avatar">

            {{
            patient.firstName?.charAt(0)?.toUpperCase() ||
            '?'
            }}

            {{
            patient.lastName?.charAt(0)?.toUpperCase() ||
            ''
            }}

          </div>


          <!-- DETAILS -->

          <div class="same-rmn-patient-info">

            <div class="same-rmn-patient-name">

              {{ patient.firstName || '' }}

              {{ patient.middleName || '' }}

              {{ patient.lastName || '' }}

            </div>


            <div class="same-rmn-patient-meta">

              <span>
                {{ patient.contactNo || mobileNumber }}
              </span>

              <span class="same-rmn-separator">
                •
              </span>

              <span>
                {{ patient.gender || '-' }}
              </span>

            </div>


            <!-- OPTIONAL DOB -->

            <div class="same-rmn-patient-dob" *ngIf="patient.DOB">

              DOB:
              {{ patient.DOB }}

            </div>

          </div>


          <!-- SELECT INDICATOR -->

          <div class="same-rmn-select">

            <div class="same-rmn-radio" [class.active]="selectedPatient === patient">

              <mat-icon *ngIf="selectedPatient === patient">

                check

              </mat-icon>

            </div>

          </div>

        </div>

      </div>


      <!-- EMPTY STATE -->

      <div class="same-rmn-empty" *ngIf="patientList.length === 0">

        <mat-icon>
          person_off
        </mat-icon>

        <p>
          No patient information available.
        </p>

      </div>

    </div>


    <!-- ================= FOOTER ================= -->

    <div class="same-rmn-footer">


      <!-- MODIFY RMN -->

      <button type="button" class="modify-rmn-btn" (click)="modifyRMN(modal)">

        <mat-icon>
          edit
        </mat-icon>

        Modify RMN

      </button>


      <!-- PROCEED -->

      <button type="button" class="proceed-rmn-btn" (click)="proceedWithSameRMN(modal)">

        <mat-icon>
          arrow_forward
        </mat-icon>

        Proceed With Same RMN

      </button>

    </div>

  </div>

</ng-template>